/**
 * Web Push の applicationServerKey 用。
 * VAPID 公開鍵は URL-safe Base64（パディング省略可）で環境変数に渡す。
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array/fromBase64
 */
export function vapidPublicKeyToApplicationServerKey(
    vapidPublicKey: string
): ArrayBuffer {
    const bytes = Uint8Array.fromBase64(vapidPublicKey, {
        alphabet: "base64url",
    });
    const out = new ArrayBuffer(bytes.byteLength);
    new Uint8Array(out).set(bytes);
    return out;
}
